import React, { Component } from 'react';
import { Container, Typography, Box, Link, Grid } from '@mui/material';

import { Helmet } from "react-helmet-async";

import about from '../../assets/about.jpg'
import journey from '../../assets/journey.jpg'
import expert from '../../assets/expert.jpg'
import philosophy from '../../assets/philosophy.jpg'
import comitment from '../../assets/comitment.jpg'

import FadeInSection from '../useInView';

class AboutUsPage extends Component {
  render() {

    const containerStyle = {
      backgroundImage: `url(${about})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    };

    return (
      <Container maxWidth="lg">
        <Helmet>
          <title>About Us - Robotics Media</title>
          <meta name="description" content="Robotics Media is a Bristol, United Kingdom digital agency delivering web development, custom software, IoT and CCTV systems, brand design, and media production. Learn our story, values, and how we help businesses grow." />
          <meta name="keywords" content="Robotics Media, Bristol, United Kingdom, web development, custom software, IoT, CCTV, brand design, graphic design, photography, videography, media production, digital agency" />
        </Helmet>
        <Box sx={{ height: '150px' }} />
        <FadeInSection>
        <Container  sx={{ height: '100%', alignContent: 'center', alignItems: 'center' }} style={containerStyle} >
          <Typography variant="h3" color='white' gutterBottom>
            About Us
          </Typography>
        </Container>
        <br /><br />
        <Typography className='code-element' variant="code" fontSize='1.5rem' color='white' gutterBottom>
          Robotics Media: Bristol Based Digital Transformation Partner
        </Typography>
        <br /><br />
        <Typography className='code-element' variant='code' fontSize='1.2rem' color='white' paragraph>
          Robotics Media is a Bristol, United Kingdom agency built to help businesses grow through smart technology, strong branding, and standout content. We combine full-stack development, secure IT systems, and creative production so you can launch faster, sell more, and scale with confidence. Our work spans web development, custom software, IoT and CCTV systems, brand identity, photography, and video production, all delivered by one integrated team.
        </Typography>
        </FadeInSection>
        <br />

        { /* Journey */}
        <FadeInSection>
          <Typography variant="h5" color='white' gutterBottom>
            Our Journey
          </Typography>
          <br />
          <Container sx={{ height: '100%', alignContent: 'center', alignItems: 'center' }}>
            <Grid container spacing={2} alignItems="center" justify="center" style={{ height: '100%' }}>
              <Grid item xs={12} md={6}>
                {/* Assuming you want to place an image here */}
                <img src={journey} alt="Our Journey" style={{ borderRadius: '20px', maxWidth: '100%', height: 'auto' }} />
              </Grid>
              <Grid item xs={12} md={6}>
          <Typography className='code-element' variant='body1' fontFamily='Pt Mono' fontSize='1.2rem' color='white' paragraph>
            We started in Bristol with a simple goal: bring technical expertise and creative clarity together under one roof. What began as a small team has grown into a full-service studio trusted by businesses across the UK and abroad. Every project is shaped by real business needs, from improving operations with custom software to building brands that are easy to recognize and hard to forget.
          </Typography>
              </Grid>
            </Grid>
          </Container>
        </FadeInSection>


        <br /> <br />
        { /* Expertise */}
        <FadeInSection>
        <Typography variant="h5" color='white' justifyContent='center' alignItems='flex-end' gutterBottom>
          Our Expertise
        </Typography>
        <br />
        <Container sx={{ height: '100%', alignContent: 'center', alignItems: 'center' }}>
          <Grid container spacing={2} alignItems="center" justify="center" style={{ height: '100%' }}>
            <Grid item xs={12} md={6}>
          <Typography className='code-element' variant='code' fontSize='1.2rem' color='white' paragraph>
            Our expertise covers the full path from idea to launch, with clear, practical services that businesses can act on:
          </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <img src={expert} alt="Our Journey" style={{ borderRadius: '20px', maxWidth: '100%', height: 'auto' }} />

            </Grid>
          </Grid>
        </Container>
        </FadeInSection>

        <br /><br />
        <FadeInSection>
        <Box pl={2}>
          <Typography className='code-element' variant='code' fontSize='1.2rem' color='white' paragraph>- Web and Software: Full-stack web development, custom software, integrations, and automation.</Typography>
          <Typography className='code-element' variant='code' fontSize='1.2rem' color='white' paragraph>- IT and Security: IoT systems, CCTV installations, network setup, and ongoing support.</Typography>
          <Typography className='code-element' variant='code' fontSize='1.2rem' color='white' paragraph>- Brand and Design: Identity, UI/UX, and marketing assets that drive conversion.</Typography>
          <Typography className='code-element' variant='code' fontSize='1.2rem' color='white' paragraph>- Media Production: Photography, video, and content for campaigns, products, and events.</Typography>
        </Box>
        </FadeInSection>
        <br /><br />
        { /* Philosophy */}
        <FadeInSection>
        <Typography variant="h5" color='white' gutterBottom>
          Our Philosophy
        </Typography>
        <br />
        <Container sx={{ height: '100%', alignContent: 'center', alignItems: 'center' }}>
          <Grid container spacing={2} alignItems="center" justify="center" style={{ height: '100%' }}>
            <Grid item xs={12} md={6}>
              {/* Assuming you want to place an image here */}
              <img src={philosophy} alt="Our Journey" style={{ borderRadius: '20px', maxWidth: '100%', height: 'auto' }} />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography className='code-element' variant='code' fontSize='1.2rem' color='white' paragraph>
                We believe the best results come from clear communication, measurable goals, and thoughtful execution. Our team focuses on outcomes, not hype, using proven tools and creative thinking to build solutions that are easy to use and ready to scale.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        </FadeInSection>

        <br /> <br />
        { /* Commitment to You */}
        <FadeInSection>
        <Typography variant="h5" color='white' justifyContent='center' alignItems='flex-end' gutterBottom>
          Our Commitment to You
        </Typography>
        <br />
        <Container sx={{ height: '100%', alignContent: 'center', alignItems: 'center' }}>
          <Grid container spacing={2} alignItems="center" justify="center" style={{ height: '100%' }}>
            <Grid item xs={12} md={6}>
              <Typography className='code-element' variant='code' fontSize='1.2rem' color='white' paragraph>
                From our Bristol base, we work with startups and established companies to build reliable systems, strong brands, and compelling content. We take time to understand your audience, map the right strategy, and deliver work that drives real growth.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <img src={comitment} alt="Our Journey" style={{ borderRadius: '20px', maxWidth: '100%', height: 'auto' }} />
            </Grid>
          </Grid>
        </Container>
        </FadeInSection>
        <br /><br />

        { /* Connect With Us */}
        <FadeInSection>
        <Typography variant="h5" color='white' justifyContent='center' alignItems='flex-end' gutterBottom>
          Connect With Us
        </Typography>
        <br />
        <Container sx={{ height: '100%', alignContent: 'center', alignItems: 'center' }}>
          <Grid container spacing={2} alignItems="center" justify="center" style={{ height: '100%' }}>
            <Grid item xs={12} md={6}>
              <Typography className='code-element' variant='code' fontSize='1.2rem' color='white' paragraph>
                If you need a team that can handle development, design, media, and security under one roof, we are ready to help. Reach out for a free consultation and a clear plan tailored to your business.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography className='code-element' variant='code' fontSize='1rem' color='white' paragraph>
                Website: <Link href="http://robotics-media.com" color="inherit">robotics-media.com</Link><br />
                Email: <Link href="mailto:contact@robotics-media.com" color="inherit">contact@robotics-media.com</Link><br />
                Phone: <Link href="tel:+447949628183" color="inherit">07949 628 183</Link>
              </Typography>
            </Grid>
          </Grid>
        </Container>
        </FadeInSection>
        <br />
        <FadeInSection>
        <Typography className='code-element' variant='code' fontSize='1rem' color='white' paragraph>
          Join us at Robotics Media, where your digital future begins today.
        </Typography>
        </FadeInSection>
      </Container>
    );
  }
}

export default AboutUsPage;
